import React from 'react';
import { StyledCardBox } from './style/style';

const CardBox = (props) => {
	const {
		title,
		children,
		classButton,
		textButton,
		linkButton,
		eventButton,
		classComponent,
		targetButton,
		boxShadow,
	} = props;

	return (
		<StyledCardBox boxShadow={boxShadow} className={classComponent}>
			<div className="content-header">
				<h4>{title}</h4>
			</div>
			<div className="content-body testeText testeTextTwo">
				{children}
				<a
					id="download-media-kit"
					href={linkButton}
					rel="noopener noreferrer"
					target={targetButton}
					className={classButton}
					onClick={eventButton}
				>
					{textButton}
				</a>
			</div>
		</StyledCardBox>
	);
};

export default CardBox;
